var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedinmono = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand=linkedin, monochrome=True"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06032 20.5H7.28898V8.66156H4.06032V20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79126 5.39846C3.79126 6.4467 4.63502 7.29691 5.67465 7.29691C6.71535 7.29691 7.55804 6.4467 7.55804 5.39846C7.55804 4.35022 6.71428 3.5 5.67465 3.5C4.63502 3.5 3.79126 4.35022 3.79126 5.39846Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.975 20.5H20.2036V13.2258C20.2036 7.57242 14.1725 7.77798 12.6701 10.5611V8.66156H9.44142V20.5H12.6701V14.4689C12.6701 11.1186 16.975 10.8441 16.975 14.4689V20.5Z"
  })))));
};
export default SvgLinkedinmono;